<template>
  <div>
    <v-dialog
      v-model="check_dialog"
      max-width="500px"
      transition="dialog-transition"
      v-if="check_dialog"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title class="blue-grey white--text py-1 mb-3 py-2">
          <v-btn icon class="mr-2">
            <v-icon class="white--text" @click="$emit('close')">mdi-close</v-icon>
          </v-btn>
          Cheque:
        </v-card-title>
        <v-card-text>
          <v-form readonly class="mt-2">
            <v-row justify="center">
              <v-col class="py-0">
                <v-text-field label="Cliente" :value="one_check.client_name"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="5" class="py-0">
                <v-text-field label="Pago em" :value="$moment(one_check.payed_at?.substring(0,10)).format('L')"></v-text-field>
              </v-col>
              <v-col cols="5" class="py-0">
                <v-text-field label="Envelope" :value="one_check.envelope_name"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="5" class="py-0">
                <v-text-field label="Confirmado por" :value="one_check.confirmed_by_name"></v-text-field>
              </v-col>
              <v-col cols="5" class="py-0">
                <v-text-field label="Confirmado em" :value="$moment(one_check.confirmed_at?.substring(0,10)).format('L')"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row justify="center">
            <v-expansion-panels accordion multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>Informações do Cheque</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-form readonly>
                    <v-row>
                      <v-text-field label="Banco" :value="one_check.bank"></v-text-field>
                    </v-row>
                    <v-row>
                      <v-text-field label="Agência" :value="one_check.agency"></v-text-field>
                    </v-row>
                    <v-row>
                      <v-text-field label="Conta" :value="one_check.account_number"></v-text-field>
                    </v-row>
                    <v-row>
                      <v-text-field label="Núm. Cheque" :value="one_check.check_number"></v-text-field>
                    </v-row>
                    <v-row>
                      <v-text-field label="Bom para" :value="$moment(one_check.good_to?.substring(0,10)).format('L')"></v-text-field>
                    </v-row>
                    <v-row>
                      <v-text-field label="Valor (R$)" :value="one_check.value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})"></v-text-field>
                    </v-row>
                    <v-row>
                      <v-text-field label="Nominal" :value="one_check.nominal"></v-text-field>
                    </v-row>
                    <v-row>
                      <v-text-field label="CPF Nominal" :value="one_check.nominal_cpf"></v-text-field>
                    </v-row>
                  </v-form>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>Anexos</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify="center" class="mb-5" v-if="false">
                    <attach-doc :existing_doc="one_check.document" @donePhoto="handleDoneDoc" @removePhoto="handleRemoveDoc" mode="carrier"></attach-doc>
                    <v-row v-if="new_attach && isFinancials">
                      <v-btn color="success" @click="submitNewAttach()">Atualizar frente</v-btn>
                    </v-row>
                  </v-row>
                  <v-row justify="center" class="mb-5" v-if="false">
                    <attach-doc :existing_doc="one_check.document" @donePhoto="handleDoneDoc" @removePhoto="handleRemoveDoc" mode="carrier"></attach-doc>
                    <v-row v-if="new_attach && isFinancials">
                      <v-btn color="success" @click="submitNewAttach()">Atualizar costas</v-btn>
                    </v-row>
                  </v-row>

                  <FileAttachment :readonly="!can_edit" :update_infos="{MODEL: 'Check', id: one_check.id}" :attached_file_url="one_check.attached_file_url" @newFileUrl="handleNewFileUrl"></FileAttachment>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-col  class="d-flex justify-center" v-if="isFinancials && !one_check.returned">
            <v-btn color="error" width="50%" rounded @click="problemCheck()"><v-icon left>mdi-alert-circle</v-icon>Problema</v-btn>
          </v-col>
          <v-col cols="12" align='center' v-if="one_check.returned">
            <v-alert type="error" :value="true">
              <div>
                Cheque retornado! 
              </div>
              <div>
                Motivo: {{one_check.returned_due}}
              </div>
              <div>
                Retornado em: {{$moment(one_check.updated_at?.substring(0,10)).format('L')}}
              </div>
            </v-alert>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <problem-dialog v-if="problem_dialog" :problem_dialog="problem_dialog" :check="one_check" @doneReturned="handleDoneReturned" @closeDialog="handleCloseDialog" ></problem-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'CheckDialog',
  components: {
    AttachDoc: () => import('../../shipping/driver/AttachDoc'),
    ProblemDialog: () => import('./ProblemDialog'),
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
  },
  props: {
    check: {
      type: Object
    },
    check_dialog: {
      type: Boolean
    }
  },
  data() {
    return {
      edit_dialog: false,
      one_check: {},

      new_attach: 0,
      new_document_back: {},
      new_document_front: {},

      problem_dialog: false,
    }
  },
  methods: {
    updateCheck(obj, with_emit = false){
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      Api.Check.update(obj).then(r => r.data).then(r => {
        this.one_check = {
          ...this.one_check,
          ...r,
        }
        if (with_emit){
          this.$emit('doneUpdate')
        }
      }).catch(error => {
        console.log(error)
        noti = {
          type: 'error',
          msg: `Erro: ${error}`
        }
      }).finally(()=>{
        this.loading_saving = false
        this.addNotification(noti)
      })
    },
    handleNewFileUrl(data){
      // this.handleDoneUpdate(data)
      this.one_check = {
        ...this.one_check,
        attached_file_url: data.url
      }
      this.$emit('updatedCheck', this.one_check)
    },
    setupOneCheck(){
      this.one_check = {
        ...this.check
      }
    },
    submitNewAttach(){
      const {id, } = this.one_check
      let obj = {
        id, 
        document: this.new_document
      }
      this.updateCheck(obj, true)
    },
    handleDoneDoc(e) {
      this.new_attach += 1
      this.new_document = {...e}
    },
    handleRemoveDoc(){
      this.$emit('removeDoc')
      this.new_attach = false
      this.new_document = {}
    },
    handleCloseDialog(){
      this.problem_dialog = false
    },
    problemCheck(){
      this.problem_dialog = true
    },
    handleDoneReturned(e){
      this.problem_dialog = false
      this.$emit('doneReturned')
    },
  },
  computed: {
    can_edit(){
      return this.isAnalyst() || this.isDirector() || this.isManager() 
    },
    isFinancials() {
      return this.isFinancial() || this.isDirector()
    },
  },
  watch: {
    check_dialog(nv) {
      if (nv) {
        this.setupOneCheck()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
